<template>
  <div v-if="variant === 'segmented'" class="k-theme-switch" role="radiogroup" aria-label="Thème">
    <button
      type="button"
      class="k-theme-switch__option"
      :class="{ 'k-theme-switch__option--active': !isDark }"
      role="radio"
      :aria-checked="!isDark"
      aria-label="Thème clair"
      @click="setTheme(false)"
    >
      <v-icon icon="mdi-white-balance-sunny" size="18" />
    </button>
    <button
      type="button"
      class="k-theme-switch__option"
      :class="{ 'k-theme-switch__option--active': isDark }"
      role="radio"
      :aria-checked="isDark"
      aria-label="Thème sombre"
      @click="setTheme(true)"
    >
      <v-icon icon="mdi-weather-night" size="18" />
    </button>
  </div>

  <v-tooltip v-else location="bottom">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        icon
        variant="text"
        size="small"
        :aria-label="isDark ? 'Passer en thème clair' : 'Passer en thème sombre'"
        @click="setTheme(!isDark)"
      >
        <v-icon :icon="isDark ? 'mdi-weather-night' : 'mdi-white-balance-sunny'" />
      </v-btn>
    </template>
    <span>{{ isDark ? "Passer en thème clair" : "Passer en thème sombre" }}</span>
  </v-tooltip>
</template>

<script>
import { useUserStore } from "@/stores/user";

export default {
  name: "ComponentDarkModeSwitch",
  props: {
    variant: {
      type: String,
      default: "icon",
      validator: value => ["icon", "segmented"].includes(value),
    },
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.current.dark;
    },
  },
  methods: {
    setTheme(dark) {
      const theme = dark ? "dark" : "light";
      this.$vuetify.theme.change(theme);

      if (this.userStore.user)
        this.userStore.updateTheme(theme);
    },
  },
};
</script>

<style scoped>
.k-theme-switch {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border: 1px solid var(--k-glass-border);
  border-radius: 999px;
  background: var(--k-track);
}

.k-theme-switch__option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 28px;
  color: inherit;
  cursor: pointer;
  opacity: 0.55;
  background: transparent;
  border: 0;
  border-radius: 999px;
  transition: background var(--k-dur-base) var(--k-ease-out), opacity var(--k-dur-base);
}

.k-theme-switch__option--active {
  opacity: 1;
  color: #fff;
  background: rgb(var(--v-theme-primary));
}

@media (prefers-reduced-motion: reduce) {
  .k-theme-switch__option {
    transition: none;
  }
}
</style>
